import React from "react";
import { Box, Typography } from "@mui/material";
import SrDetailDump from "./SrDetailDump";

/**
 * Status Reports — SR status/detail dump view.
 * Route: /reports/status (menuConfig REPORT_STATUS).
 */
const StatusReports = () => (
  <Box>
    <Typography variant="h5" sx={{ px: 2, pt: 2, pb: 0, fontWeight: 600 }}>
      Status Reports
    </Typography>
    <SrDetailDump />
  </Box>
);

export default StatusReports;
